var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { class: { "past-deadline": _vm.task.isPastDeadline, "border-0": true } },
    [
      _vm.task.showDeadline || _vm.task.isPastDeadline
        ? _c("td", [
            _c("div", [
              _vm.task.showDeadline
                ? _c("span", [
                    _vm._v(_vm._s(_vm._f("formatDate")(_vm.task.deadline)))
                  ])
                : _vm._e(),
              _c("br"),
              _vm._v(" "),
              _vm.task.isPastDeadline
                ? _c("span", { staticClass: "past-deadline" }, [
                    _vm._v(
                      _vm._s(_vm._f("toUpperCase")(_vm.$t("PastDeadline")))
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _c("td", { staticClass: "centered" }, [_vm._m(0)]),
      _vm._v(" "),
      _vm.task.displayTaskType
        ? _c("td", { class: { bold: _vm.task.requiresAction } }, [
            _c(
              "span",
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.task.displayTaskType) + "\n      "
                ),
                _vm.task.isAidDecision
                  ? _c("tooltip-icon", {
                      attrs: {
                        content: _vm.$t("Forms.AidDecision_Description")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.task.isInvestmentReport && !_vm.task.isInvestmentDecision
                  ? _c("tooltip-icon", {
                      attrs: {
                        content: _vm.$t(
                          "Forms.InvestmentReport" +
                            _vm.task.subTaskString +
                            "_Description"
                        )
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _c("td", { staticClass: "centered" }, [_c("span", [_vm._v("-")])]),
      _vm._v(" "),
      _vm.task.aidTargetNumber
        ? _c("td", [_c("span", [_vm._v(_vm._s(_vm.task.aidTargetNumber))])])
        : _c("td", { staticClass: "centered" }, [_c("span", [_vm._v("-")])]),
      _vm._v(" "),
      _vm.task.purpose
        ? _c("td", [
            _c(
              "div",
              {
                staticClass: "d-none d-xl-block",
                attrs: {
                  title: _vm.task.purpose.length > 140 ? _vm.task.purpose : ""
                }
              },
              [_vm._v(_vm._s(_vm._f("truncate")(_vm.task.purpose, 140)))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-block d-xl-none",
                attrs: {
                  title: _vm.task.purpose.length > 60 ? _vm.task.purpose : ""
                }
              },
              [_vm._v(_vm._s(_vm._f("truncate")(_vm.task.purpose, 60)))]
            )
          ])
        : _c("td", { staticClass: "centered" }, [_c("div", [_vm._v("-")])]),
      _vm._v(" "),
      _vm.task.arrivalOrCreatedDate
        ? _c("td", [
            _c("div", [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm._f("formatDate")(_vm.task.arrivalOrCreatedDate, true)
                  )
                )
              ]),
              _c("br")
            ])
          ])
        : _c("td", { staticClass: "centered" }, [_vm._m(1)]),
      _vm._v(" "),
      _c("td", { staticClass: "centered" }, [
        _c(
          "span",
          [
            _vm.procurationOnly
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.top.center",
                        value: { content: _vm.$t("Btn_Open_ProcurationOnly") },
                        expression:
                          "{ content: $t('Btn_Open_ProcurationOnly') }",
                        modifiers: { top: true, center: true }
                      }
                    ],
                    attrs: { tabindex: "0" }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: {
                          type: "button",
                          disabled: "",
                          "aria-disabled": "true",
                          "aria-label":
                            _vm.$t(
                              _vm.task.isPastDeadline ? "Btn_Show" : "Btn_Open"
                            ) +
                            " " +
                            _vm.task.displayTaskType +
                            " " +
                            (_vm.task.purpose ? _vm.task.purpose : "")
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              _vm.task.isPastDeadline ? "Btn_Show" : "Btn_Open"
                            )
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Btn_Open_ProcurationOnly")))
                    ])
                  ]
                )
              : _c(
                  "router-link",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: {
                      to: {
                        name: _vm.task.routeValue,
                        params: { id: _vm.task.recordId }
                      },
                      tag: "button",
                      "aria-label":
                        _vm.$t(
                          _vm.task.isPastDeadline ? "Btn_Show" : "Btn_Open"
                        ) +
                        " " +
                        _vm.task.displayTaskType +
                        " " +
                        (_vm.task.purpose ? _vm.task.purpose : "")
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            _vm.task.isPastDeadline ? "Btn_Show" : "Btn_Open"
                          )
                        ) +
                        "\n      "
                    )
                  ]
                )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", [_vm._v("-")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", [_vm._v("-")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }